import React from "react";
import { PropertyTable } from "./overview/PropertyTable";
import { OverviewContainer } from "../../common/OverviewContainer";

export function PropertyOverview() {
  return (
    <OverviewContainer title={null}>
      <PropertyTable />
    </OverviewContainer>
  );
}
